import { configureStore } from "@reduxjs/toolkit";
import clientSlice from "./slices/clientSlice";
import companySlice from "./slices/companySlice";
import contactSlice from "./slices/contactSlice";
import employeeSlice from "./slices/employeeSlice";
import faqSlice from "./slices/faqSlice";
import MasterSlice from "./slices/MasterSlice";
import organizationSlice from "./slices/organizationSlice";
import teamSlice from "./slices/teamSlice";
import taskSlice from "./slices/taskSlice";
import latterSlice from "./slices/latterSlice";
import ladderLetterSlice from "./slices/ladderLetterSlice";
import numberSlice from "./slices/numberSlice";
import wordSlice from "./slices/wordSlice";
import sentenceSlice from "./slices/sentenceSlice";
import categorySlice from "./slices/categorySlice";
import touenamentSlice from "./slices/touenamentSlice";
import challengeSlice from "./slices/challengeSlice";
import badgeSlice from "./slices/badgeSlice";
import teacherSlice from "./slices/teacherSlice";
import SchoolSlice from "./slices/SchoolSlice";
import blogSlice from "./slices/blogSlice";
import subadminSlice from "./slices/subadminSlice";
import subscrptionSlice from "./slices/subscriptionSlice";

const store = configureStore({
    reducer: {
        master: MasterSlice,
        subscription:subscrptionSlice,
        school:SchoolSlice,
        subadmin:subadminSlice,
        teacher:teacherSlice,
        company: companySlice,
        blog:blogSlice,
        badge:badgeSlice,
        team: teamSlice,
        employee: employeeSlice,
        challenge:challengeSlice,
        client: clientSlice,
        faq:faqSlice,
        letter: latterSlice,
        number: numberSlice,
        word: wordSlice,
        ladder: ladderLetterSlice,
        category:categorySlice,
        tournament:touenamentSlice,
        sentence:sentenceSlice,
        contact:contactSlice,
        organization:organizationSlice,
        task:taskSlice,
    },
});

export default store;
